<template>
  <div>
    <div
      v-if="loading" class="d-flex flex-column justify-center align-center"
      style="height: calc(100vh - 64px - 48px)"
    >
      <v-progress-circular indeterminate></v-progress-circular>
    </div>
    <template v-else>
      <template v-if="tableInUse||fastFoodMode">
        <v-card class="d-flex align-center" flat style="position: sticky;top: 48px;z-index: 1" tile>
          <template v-if="!showSearch">
            <v-btn
              class="ml-2"
              icon
              @click="expandAllCategories = !expandAllCategories"
            >
              <v-icon>mdi-menu</v-icon>
            </v-btn>
            <div class="category-tab-wrapper">
              <div
                ref="categoryTab"
                class="px-2"
                style="align-items: center;display: grid;grid-auto-flow: column;grid-auto-columns: min-content;grid-gap: 4px;overflow-x: scroll"
              >
                <div
                  v-for="(category) in categoryWithDishesInfo"
                  :id="'navItem'+category.id"
                  :key="category.id"
                  :class="category.id===activeCategoryId?'primary--text font-weight-black':''"
                  class="text-no-wrap categoryChipItem text-capitalize" @click="gotoCategory(category)"
                >
                  {{ category.name }}
                </div>
              </div>
            </div>

            <div class="d-flex align-center">
              <v-btn
                class="mr-2"
                icon
                @click="showSearchField"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </div>
          </template>

          <template
            v-else
            class="d-flex">
            <v-text-field
              v-model="searchWord"
              :placeholder="$t('Search')"
              append-icon="mdi-close"
              autofocus
              class="pa-2"
              hide-details
              outlined
              @input="showAllSearchDishes"
              @click:append="showSearch=false;searchWord=''"
            ></v-text-field>
          </template>
        </v-card>
        <div  v-if="!searchWord" class="pb-12">
          <div v-for="category in categoryWithDishesInfo" :key="category.id">
            <div
              :id="'category'+category.id" v-intersect="{handler:e=>onIntersect(e,category),options:{
          }}"
            ></div>
            <div class="px-4 py-2 mt-2">
              <div class="text-body-1 amber--text text--lighten-4 font-weight-bold text-capitalize">{{
                  category.name
                }}
              </div>
              <div class="text-body-2">{{ category.desc }}</div>
            </div>
            <dish-card
              v-for="dish in category.dishes"
              :key="dish.id"
              :count="currentTotalCount(dish.code)"
              :dish="dish"
              :image-root="GlobalConfig.imageRoot"
              @add="updateCart(dish,1)"
              @click="currentDish=dish;showDishDetailSheet=true"
              @minus="currentTotalCount(dish.code)>0?updateCart(dish,-1):null"
            />
          </div>
        </div>
        <div
          v-else
          style="min-height: 100vh">
          <template v-if="filteredDish.length>0">
            <dish-card
              v-for="dish in filteredDish"
              :key="dish.id"
              :count="currentTotalCount(dish.code)"
              :dish="dish"
              :image-root="GlobalConfig.imageRoot"
              @add="updateCart(dish,1)"
              @click="currentDish=dish;showDishDetailSheet=true"
              @minus="currentTotalCount(dish.code)>0?updateCart(dish,-1):null"/>
          </template>
          <template v-else>
            <div
              class="d-flex align-center justify-center flex-column pa-8 pt-16 mt-16">
              <v-icon
                class="mt-n16"
                size="64">mdi-text-search
              </v-icon>
              <div class="mt-4">{{ $t('NoSearchResults') }}</div>
            </div>
          </template>

        </div>
        <div v-if="allergenList.length > 0" class="d-flex align-center justify-center pb-8 pa-4">
          <div>
            <v-btn
              elevation="0"
              height="30px"
              rounded
              text
              @click="showAllergen = true"
            >
              {{ $t("allergen") }}
              <v-icon small>mdi-information-outline</v-icon>
            </v-btn>
          </div>
        </div>
      </template>
      <template v-else>
        <div style="height: calc(100vh - 64px - 48px)">
          <loading-page></loading-page>
        </div>
      </template>

    </template>

    <v-dialog v-model="expandAllCategories" fullscreen>
      <v-card color="black" style="position: relative" tile>
        <div class="pa-4">
          <div class="d-flex align-center" style="width: 100%">

            <div class="text-h6">
              {{ $t("MenuOverview") }}
            </div>
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click="expandAllCategories = false"
            >
              <v-icon>
                mdi-close-circle
              </v-icon>
            </v-btn>
          </div>


          <div>
            <div v-if="noDrinkCategory !== []">
              <div class="text-body-2 text--secondary mt-6">{{ $t("Meal") }}</div>
              <div
                class="mt-4"
                style="display: grid;grid-template-columns: repeat(3,minmax(0,1fr));grid-gap: 8px"
              >
                <v-card
                  v-for="category in noDrinkCategory"
                  :key="category.id"
                  flat @click="gotoCategory(category); expandAllCategories = false"
                >
                  <v-img
                    :src="GlobalConfig.resourceRoot+category.dcImage"
                    gradient="to bottom, rgba(0,0,0,.5), rgba(0,0,0,.33)"
                    style="position: absolute;top:0;left: 0;right: 0;bottom: 0;border-radius: 8px"
                  />
                  <v-responsive :aspect-ratio="1">
                    <div class="text-h6 pa-2 font-weight-black" style="height: 100%">
                      {{ category.name }}
                    </div>
                  </v-responsive>


                </v-card>
              </div>
            </div>
            <div v-if="drinkCategory!==[]">
              <div class="text-body-2 text--secondary mt-6">{{ $t("Drinks") }}</div>
              <div
                class="mt-4"
                style="display: grid;grid-template-columns: repeat(3,minmax(0,1fr));grid-gap: 8px"
              >
                <v-card
                  v-for="category in drinkCategory"
                  :key="category.id"
                  flat @click="gotoCategory(category); expandAllCategories = false"
                >
                  <v-img
                    :src="GlobalConfig.resourceRoot+category.dcImage"
                    gradient="to bottom, rgba(0,0,0,.5), rgba(0,0,0,.33)"
                    style="position: absolute;top:0;left: 0;right: 0;bottom: 0;border-radius: 8px"
                  />
                  <v-responsive :aspect-ratio="1">
                    <div class="text-h6 pa-2 font-weight-black text-capitalize" style="height: 100%">
                      {{ category.name }}
                    </div>
                  </v-responsive>


                </v-card>
              </div>
            </div>
          </div>
        </div>

      </v-card>

    </v-dialog>
    <v-card
      v-if="dishCount>0&&!fastFoodMode"
      class="d-flex pa-4 align-center justify-center"
      color="primary"
      elevation="4"
      light
      style="position: fixed; right :5vw;left: 5vw; min-width:140px;z-index: 100;border-radius: 30px;bottom:76px"
      @click="showCart=!showCart"
    >

      <v-badge :content="dishCount" color="secondary" offset-x="20" overlap>
        <v-icon class="mr-2">mdi-shopping-outline</v-icon>
      </v-badge>
      <div class="text-body-1 font-weight-bold ml-4 text-capitalize">{{ $t("Cart") }}</div>
    </v-card>
    <v-card
      v-if="fastFoodMode"
      class="rounded-t-xl pa-4"
      color="black"
      style="position: fixed;right: 0;left: 0;bottom: 0;z-index: 100"
    >
      <div class="d-flex align-center justify-center">
        <div>{{ $t(modeDisplay) }}</div>
        <v-spacer></v-spacer>
        <v-btn :disabled="tableInUse" icon @click="gotoIndexPage">
          <v-icon>mdi-reload</v-icon>
        </v-btn>
      </div>
      <div class="mt-2" style="display: grid;grid-gap: 24px;grid-template-columns: repeat(2,minmax(0,1fr));">
        <v-card
          :color="dishCount>0?'primary':'grey darken-4'"
          :light="dishCount>0"
          class="d-flex justify-center align-center pa-4"
          rounded="xl"
          @click="dishCount>0?showCart=true:null"
        >

          <v-icon class="mr-2">mdi-shopping-outline</v-icon>
          <div v-if="dishCount>0">{{ dishCount }}</div>

        </v-card>
        <v-card
          :color="tableInUse?'green lighten-3':'grey darken-4'"
          :light="tableInUse"
          class="d-flex justify-center align-center pa-4"
          rounded="xl"
          @click="showOrderPage"
        >

          <v-icon class="mr-2">mdi-wallet</v-icon>
        </v-card>
      </div>

    </v-card>
    <dish-detail-sheet
      :dish="currentDish"
      :image-root="GlobalConfig.imageRoot"
      :show="showDishDetailSheet"
      @modification-cancel="cancelEdit"
      @modification-submit="submitModification"
    />
    <v-bottom-sheet v-model="showCart" fullscreen scrollable>
      <v-card class="pa-4 black" style="overflow: scroll">
        <div class="d-flex justify-center pt-3" style="width: 100%;position: relative">
          <div class="text-h6 font-weight-bold">
            {{ $t("ShoppingCart") }}
          </div>
          <v-btn icon style="position: absolute;right: 56px;top:10px" @click="confirmClearCart = true">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-btn icon style="position: absolute;right: 16px;top:10px" @click="showCart=false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="d-flex flex-column justify-center align-center mt-12" style="width: 100%">
          <div class="text-body-2 text--secondary font-weight-medium">{{ $t("Total") }}</div>
          <div class="mt-2 text-h4 font-weight-bold">
            {{ totalPriceWithoutMod | priceDisplay }}
          </div>
          <div class="text-caption text--secondary mt-2">{{ $t("IncludeVat") }}</div>
        </div>
        <div class="pb-16 mt-12">
          <div v-for="user in Object.keys(globalCartList)" :key="user">
            <div class="text-body-2 px-4 py-2">
              {{ user }}
              <template v-if="user==userStore.userName">({{ $t("me") }})</template>
            </div>

            <v-card
              v-for="dish in globalCartList[user]"
              :key="dish.id"
              class="pa-4 mb-3 mx-4"
              color="grey darken-4"
              elevation="0"
              style="border-radius: 12px;"
            >
              <div class="d-flex flex-column">
                <div class="d-flex align-center">
                  <div class="pa-1 black" style="border-radius: 8px;height: min-content">
                    <dish-image
                      :cloud-image="dish.cloudImage" :image="dish.image" :image-root="GlobalConfig.imageRoot" :width="48"
                    />
                  </div>
                  <div class="flex-grow-1 ml-3 d-flex flex-column" style="min-height: 56px">
                    <div class="font-weight-medium text-body-1">{{ dish.dishName }}</div>
                    <div v-if="dish.displayApply.length>0" class="text-body-2 text--secondary mt-1">
                      {{ dish.displayApply.map(it => it.value).join(", ") }}
                    </div>
                    <v-spacer></v-spacer>
                    <div class="mt-1 text-body-2">
                      {{ dish.realPrice | priceDisplay }}
                    </div>
                  </div>
                  <div class=" d-flex align-center grey darken-3 mr-1" style="border-radius: 24px;">
                    <v-card
                      class="pa-2" color="grey darken-2" elevation="0" style="border-radius: 24px"
                      @click="updateCart(dish,-1)"
                    >
                      <v-icon>mdi-minus</v-icon>
                    </v-card>
                    <div class="pa-2">
                      {{ dish.count }}
                    </div>
                    <v-card
                      class="pa-2" color="grey darken-1" elevation="0" style="border-radius: 24px"
                      @click="updateCart(dish,1)"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-card>
                  </div>
                </div>
                <div v-if="dish.note" class="text-caption mt-1">Note:{{dish.note}}</div>
              </div>
            </v-card>
          </div>

        </div>
        <div style="height: 20px"></div>
        <v-card
          :disabled="submittingCart"
          class="pa-4 d-flex justify-center" color="primary black--text"
          style="border-radius: 30px; position: fixed;left: 16px;right: 5vw;bottom: 16px;z-index: 10"
          @click="showConfirmOrderDialog"
        >
          <template v-if="submittingCart">
            <v-progress-circular indeterminate></v-progress-circular>
          </template>
          <template v-else>
            <v-icon class="mr-4" color="black">mdi-check</v-icon>
            <div class="text-body-1 mr-2 font-weight-bold text-capitalize">{{ $t("OrderNow") }}</div>
          </template>
        </v-card>
      </v-card>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="showHotpotPage" fullscreen persistent scrollable>
    </v-bottom-sheet>
    <v-bottom-sheet
      v-model="showAllergen"
      fullscreen
      scrollable
    >
      <v-card
        style="overflow: scroll"
        tile
      >
        <div class="pa-4 pt-8">
          <v-btn
            class="ml-n2"
            icon
            large
            @click="showAllergen=false"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <div class="text-h4 font-weight-black">
            {{ $t("allergen") }}
          </div>
          <div class="mt-4">
            <v-card class="px-2 py-4" outlined style="border-style: dashed;border-color: white;border-width: 2px;">
              <div
                v-for="(item,index) in allergenList"
                :key="index"
                style="display: inline-block; margin-right: 10px;"
              >
                ({{ item.shortName ? item.shortName : item.name }}){{ item.name }},
              </div>
            </v-card>

          </div>
        </div>

      </v-card>
    </v-bottom-sheet>
    <v-dialog v-model="confirmClearCart">
      <v-card class="pa-6 d-flex align-center justify-center flex-column">
        <v-icon
          color="error lighten-2"
          size="48"
        >
          mdi-alert-box
        </v-icon>
        <div class="text-body-1 mt-2">
          {{ $t("confirmClearCart") }}
        </div>
        <div class="d-flex align-center justify-center">
          <v-btn
            class="amber lighten-4 black--text mt-4"
            elevation="0"
            rounded
            @click="clearCart"
          >
            {{ $t("yes") }}
          </v-btn>
          <v-btn
            class="blue lighten-4 black--text mt-4 ml-4"
            elevation="0"
            rounded
            @click="confirmClearCart=false"
          >
            {{ $t("no") }}
          </v-btn>
        </div>

      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmOrderDialog">
      <v-card class="pa-6 d-flex align-center justify-center flex-column">
        <v-icon
          color="error lighten-2"
          size="48"
        >
          mdi-alert-box
        </v-icon>
        <div class="text-body-1 mt-2">
          {{$t('sureToOrder')}}
        </div>
        <div class="d-flex align-center justify-center">
          <v-btn
            class="amber lighten-4 black--text mt-4"
            elevation="0"
            rounded
            @click="submitOrder()"
          >
            {{ $t("yes") }}
          </v-btn>
          <v-btn
            class="blue lighten-4 black--text mt-4 ml-4"
            elevation="0"
            rounded
            @click="confirmOrderDialog=false"
          >
            {{ $t("no") }}
          </v-btn>
        </div>

      </v-card>
    </v-dialog>

    <v-dialog v-model="cantDeleteDialog">
      <v-card class="pa-6 d-flex align-center justify-center flex-column">
        <v-icon
          color="error lighten-2"
          size="48"
        >
          mdi-alert-box
        </v-icon>
        <div class="text-body-1 mt-2">
          {{$t('deleteSelfOrder')}}
        </div>
        <div class="d-flex align-center justify-center">
          <v-btn
            class="amber lighten-4 black--text mt-4"
            elevation="0"
            width="80%"
            rounded
            @click="cantDeleteDialog = false"
          >
            {{ $t("Sure") }}
          </v-btn>
        </div>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DishDetailSheet from "@/views/components/DishDetailSheet.vue";
import {getOrderStatus, getTableInfo, lockSubmitOrder, orderDish} from "@/dataLayer/service/api";
import CartService, {getCollectionRef, useCartStore} from "@/dataLayer/service/CartService";
import {defaultRestaurantInfo, getCurrentRestaurantInfo} from "@/dataLayer/repository/restaurantInfo";
import DishCard from "@/views/components/DishCard.vue";
import {GlobalConfig, setTableName} from "@/dataLayer/repository/GlobalSettingManager";
import DishImage from "@/views/components/DishImage.vue";
import LoadingPage from "@/views/pages/LoadingPage.vue";
import {onSnapshot} from "firebase/firestore";
import {getAllergenList, getCategoryWithDishes} from "@/dataLayer/service/dishService";
import IKUtils from "innerken-js-utils";
import {mapStores} from "pinia";
import {useUserStore} from "@/dataLayer/userStore";
import {DishDocker} from "aaden-base-model";
import {groupBy} from "lodash-es";
import {constant, times} from "lodash";
import {Remember} from "@/plugins/firebase";
import router from "@/plugins/router";
import i18n from "@/plugins/locales/i18n";

let lastList = [];
export default {
  name: "MainPage",
  components: { LoadingPage, DishImage, DishCard, DishDetailSheet },
  data: function() {
    return {
      cantDeleteDialog: false,
      showSearch: false,
      confirmClearCart: false,
      allergenList: [],
      showAllergen: false,
      loading: true,
      showHotpotPage: false,
      activeCategoryId: null,
      expandAllCategories: false,
      drinkCategory: [],
      noDrinkCategory: [],
      modeSelected: Remember.modeSelected === 1,
      isTakeaway: Remember.isTakeaway === 1,
      fastFoodMode: !IKUtils.getQueryString("tableName"),
      showDishDetailSheet: false,
      showRestaurantInfo: false,
      currentDish: null,
      categoryWithDishesInfo: [],
      restaurantInfo: defaultRestaurantInfo,
      cart: CartService,
      globalCart: DishDocker.StandardDishesListFactory(),
      searchWord: '',
      show: false,
      GlobalConfig,
      showCart: false,
      currentTableInfo: null,
      showOrderInfo: null,
      submittingCart: false,
      userNumber: 0,
      confirmOrderDialog: false,
    };
  },
  computed: {
    filteredDish: function () {
      return this.categoryWithDishesInfo.reduce((arr, i) => {
        arr.push(...i.dishes.filter(d => {
          return d.code.toLowerCase().includes(this.searchWord.toLowerCase()) || d.dishName.toLowerCase().includes(this.searchWord.toLowerCase())
        }))
        return arr
      }, []).sort((a, b) => a.code > b.code ? 1 : -1)
    },
    modeDisplay() {
      if (Remember.takeawayMode === 1) {
        return "PickAndTakeAway";
      } else {
        return "ScanCodeDineIn";
      }
    },
    globalCartList: function() {
      return groupBy(this.globalCart.list, "sourceMark");
    },
    dishCount: function() {
      return this.globalCart.list.length > 0 ? this.globalCart.count() : 0;
    },
    cartList: function() {
      return this.cart.list?.length > 0 ? this.cart.list : [];
    },
    totalPriceWithoutMod: function() {
      return this.globalCart.list.length > 0 ? this.globalCart.total() : 0;
    },
    tableInUse: function() {
      return this.currentTableInfo?.usageStatus === "1";
    },
    ...mapStores(useUserStore, useCartStore)
  },
  methods: {
    showSearchField() {
      this.searchWord = ''
      this.showSearch = true
      this.showAllSearchDishes()
    },
    showAllSearchDishes: function () {
      this.$vuetify.goTo(10)
    },
    gotoIndexPage() {
      this.$router.push("index");
    },
    clearCart() {
      this.cartStore.clearGlobalCart();
      this.confirmClearCart = false;
      this.showCart = false;
    },
    changeActiveCategoryId(categoryId) {
      this.activeCategoryId = categoryId;
      this.$refs.categoryTab.scrollLeft = [...this.$refs.categoryTab.childNodes.values()]
        .find(it => it.id === "navItem" + categoryId).offsetLeft - 48;
    },
    currentTotalCount(code) {
      return this.cartList.filter(it => it.code === code).reduce((sum, i) => sum + parseInt(i.count), 0);
    },
    onIntersect(entries, category) {
      if (entries[0].boundingClientRect.top < 160) {
        this.changeActiveCategoryId(category.id);
      }
    },
    gotoCategory: function(category) {
      this.$vuetify.goTo(`#category${category.id}`, { offset: 90 });
    },
    showOrderPage: function() {
      if (this.tableInUse) {
        router.push("/order");
      }

    },
    submitModification: function(mod, count = 1, note = '') {
      const apply = [];
      const dish = this.currentDish;
      dish.note = note;
      if (dish.modInfo) {
        for (const i of dish.modInfo) {
          const item = {};
          item.groupId = i.id;
          if (i.multiSelect === "1") {
            item.selectId = i.select.map(x => {
              return times(x.count, constant(x.value));
            }).flat();
          } else {
            if (i.required !== "1") {
              item.selectId = i.selectValue.filter((s, index) => {
                return [(mod[i.id] - 1 ?? [])].flat().includes(index);
              });
            } else {
              item.selectId = i.selectValue.filter((s, index) => {
                return [(mod[i.id] ?? [])].flat().includes(index);
              });
            }
          }
          if (i.required === "1" && item.selectId === "") {
            item.selectId = i.selectValue[0];
          }
          apply.push(item);
        }
        dish.apply = apply;
      }

      this.addDishWithMod(dish, count);
      this.currentDish = null;
      this.showDishDetailSheet = false;
    },
    addDishWithMod: function(dish, count) {
      this.updateCart(dish, count);
    },
    updateCart: function(dish, count) {
      setTimeout(() => {
        let currentDish = {}
        if (count < 0) {
          if (dish.sourceMark && dish.sourceMark !== this.userStore.userName) {
            this.cantDeleteDialog = true
            return
          }
          if (dish.note) {
            currentDish = dish
          } else {
            const currentList = this.cart.list.filter(it => it.code === dish.code);
            if (currentList.length > 0) {
              const emptyNoteItem = currentList.find(it => !it.note);
              if (emptyNoteItem) {
                currentDish = emptyNoteItem;
              } else {
                currentDish = currentList[0];
              }
            }
          }
        } else {
          currentDish = dish
        }
        dish.sourceMark = this.userStore.userName;
        this.cart.add(currentDish, count);
        this.cartStore.syncDataUp(this.cart.list);
      }, 3);
    },
    cancelEdit() {
      this.$nextTick(() => {
        this.showDishDetailSheet = false;
      });
    },
    async showConfirmOrderDialog() {
      if (this.userNumber > 1) {
        this.confirmOrderDialog = true
      } else {
        await this.submitOrder()
      }
    },
    async submitOrder() {
      this.confirmOrderDialog = false
      this.submittingCart = true;
      try {
        if (this.fastFoodMode) {
          const list = IKUtils.deepCopy(this.globalCart.list);
          const res =  await orderDish(list);
          if (!res) {
            this.submittingCart = false;
            return
          }
          this.cart.clear();
          this.cartStore.syncDataUp(this.cart.list);
          this.cartStore.clearGlobalCart();
          this.currentTableInfo = await getTableInfo();
          await router.push("/order");
        } else {
          const lockStatus = await lockSubmitOrder()
          if (lockStatus.status === 'good') {
            const list = IKUtils.deepCopy(this.globalCart.list);
            const res =  await orderDish(list);
            if (!res) {
              this.submittingCart = false;
              return
            }
            this.cart.clear();
            this.cartStore.syncDataUp(this.cart.list);
            this.cartStore.clearGlobalCart();
          } else {
            IKUtils.showError(i18n.t('lockRule',{ nextAvailableSecond: lockStatus.nextAvailableSecond }));
            this.submittingCart = false;
            return;
          }
        }
      } catch (e) {
        console.log(e);
        IKUtils.showError(e?.message);
      }
      this.submittingCart = false;
    }
  },
  watch: {
    dishCount(val) {
      if (val === 0) {
        this.showCart = false;
      }
    }
  },
  async mounted() {
    this.loading = true;
    this.categoryWithDishesInfo = await getCategoryWithDishes("DE");
    this.drinkCategory = this.categoryWithDishesInfo.filter(i => i.dishesCategoryTypeId === "9");
    this.noDrinkCategory = this.categoryWithDishesInfo.filter(i => i.dishesCategoryTypeId !== "9");
    this.restaurantInfo = await getCurrentRestaurantInfo();
    this.allergenList = await getAllergenList();
    if (!this.fastFoodMode) {
      this.currentTableInfo = await getTableInfo();
      if (this.currentTableInfo) {
        onSnapshot(getCollectionRef(), (querySnapshot) => {
          this.userNumber = querySnapshot.docs.length;
          const totalList = [];
          querySnapshot.forEach((doc) => {
            const list = JSON.parse(doc.data().localList);
            totalList.push(...list);
          });
          totalList.forEach(it => {
            console.log(it.name + " " + it.count);
          });
          if (lastList.length > 0 && totalList.length === 0) {
            this.cart.clear();
            this.cartStore.syncDataUp(this.cart.list);
          }
          lastList = totalList;
          this.globalCart.loadList(totalList);

        });
        this.cart.loadList(await this.cartStore.getStoredCart());
      }
    } else {
      if (!this.modeSelected || !Remember.sessionId) {
        await router.replace("/index");
      } else {
        onSnapshot(getCollectionRef(), (querySnapshot) => {
          const totalList = [];
          querySnapshot.forEach((doc) => {
            const list = JSON.parse(doc.data().localList);
            totalList.push(...list);
          });
          totalList.forEach(it => {
            console.log(it.name + " " + it.count);
          });
          if (lastList.length > 0 && totalList.length === 0) {
            this.cart.clear();
            this.cartStore.syncDataUp(this.cart.list);
          }
          lastList = totalList;
          this.globalCart.loadList(totalList);

        });
        this.cart.loadList(await this.cartStore.getStoredCart());
        const orderStatus = await getOrderStatus();
        if (orderStatus?.billInfo && orderStatus?.billInfo?.consumeTypeStatusId < 5) {
          setTableName(orderStatus.billInfo.tableName);
          this.currentTableInfo = await getTableInfo();
        }
      }
    }


    this.loading = false;
  }
};
</script>

<style scoped>
::-webkit-scrollbar {
  display: none;
}

.category-tab-wrapper {
  position: relative;
  flex: 1;
  overflow: hidden;
}

/* 阴影效果 */
.category-tab-wrapper::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 100px;
  height: 100%;
  background: linear-gradient(to right, rgba(30, 30, 30, 0), rgba(30, 30, 30, 0.3), rgba(30, 30, 30, 1));
  pointer-events: none;
  z-index: 1;
}

</style>
